import { createSlice } from '@reduxjs/toolkit';
import { ReducerStatus } from 'utils/constants';
import updatePublishStatusAction from './publishEntity-action';

const publishEntitySlice = createSlice({
  name: 'publishEntity',
  initialState: {
    updatePublishEntity: {
      status: ReducerStatus.IDLE,
      error: null,
      currentEntityId: null,
      currentEntityType: null,
    },
  },
  reducers: {
    resetPublishStatus(state) {
      state.updatePublishEntity.status = ReducerStatus.IDLE;
      state.updatePublishEntity.currentEntityId = null;
      state.updatePublishEntity.currentEntityType = null;
      state.updatePublishEntity.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(updatePublishStatusAction.pending, (state, action) => {
        state.updatePublishEntity.status = ReducerStatus.LOADING;
        state.updatePublishEntity.currentEntityId = action.meta.arg.entityId;
        state.updatePublishEntity.currentEntityType =
          action.meta.arg.entityType;
      })
      .addCase(updatePublishStatusAction.fulfilled, (state) => {
        state.updatePublishEntity.status = ReducerStatus.SUCCEEDED;
        state.updatePublishEntity.currentEntityId = null;
        state.updatePublishEntity.currentEntityType = null;
      })
      .addCase(updatePublishStatusAction.rejected, (state, action) => {
        state.updatePublishEntity.status = ReducerStatus.FAILED;
        state.updatePublishEntity.error = action.payload;
      });
  },
});

export const publishEntityActions = publishEntitySlice.actions;

export default publishEntitySlice;
